import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_ZONE_VRF',
  CREATE: 'CREATE_ZONE_VRF',
  EDIT: 'EDIT_ZONE_VRF',
  DELETE: 'DELETE_ZONE_VRF',
};

export const searchVRFInZone = (pageSize, page, sorted, filtered, isPublic, zoneId) => {
  const zoneParams = zoneId === null ? { zone_id__is_null: true } : { zone_id: zoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_ZONE_VRF,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted ? sorted.map(sort => (sort.desc ? `-${sort.id}` : sort.id)).join(',') : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listVRFInZone = (pageSize, page, sorted, filtered, isPublic, zoneId) => ({
  type: ACTION.LIST,
  payload: searchVRFInZone(pageSize, page, sorted, filtered, isPublic, zoneId)
    .catch(err => Promise.reject(err.response.data)),
});

export const addVRFToZone = (outdoorId, indoorTypeId, zoneId, quantity) => {
  const formData = new FormData();
  formData.set('outdoor_id', outdoorId);
  formData.set('indoor_type_id', indoorTypeId);
  formData.set('zone_id', zoneId);
  formData.set('quantity', quantity);
  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_ZONE_VRF,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editVRFInZone = (id, quantity) => {
  const formData = new FormData();
  formData.set('quantity', quantity);
  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_ZONE_VRF}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeVRFFromZone = id => ({
  type: ACTION.DELETE,
  payload: RestClient.request({
    method: 'delete',
    url: `${Constants.API_ZONE_VRF}${id}/`,
  })
    .then(() => ({ id }))
    .catch(err => Promise.reject(err.response.data)),
});



// WEBPACK FOOTER //
// ./src/redux/zone/zone_vrf_actions.js